/*jshint esversion: 8 */
/* eslint-disable */
// f**k decorator
/** MobX */
import { observable, decorate } from 'mobx';
import { tableFieldsConfig } from './data';

class Store {
  addDialogOpen = false;
  switchAddDialog() {
    this.addDialogOpen = !this.addDialogOpen;
  }

  updateDialogOpen = false;
  switchUpdateDialog() {
    this.updateDialogOpen = !this.updateDialogOpen;
  }

  columnFilterDialogOpen = false;
  switchFilterDialog() {
    console.log(`----- switchFilterDialog`);
    this.columnFilterDialogOpen = !this.columnFilterDialogOpen;
  }

  tableFields = tableFieldsConfig;
  set(data) {
    if (undefined !== data.tableFields) this.tableFields = data.tableFields;
  }

  updateRecordOldInfo = {};
  updateRecordInfo = {};
  iniUpdateRecordInfo(data) {
    this.updateRecordOldInfo = data;
    this.updateRecordInfo = data;
  }
  updateRecord(key, value) {
    this.updateRecordInfo[key] = value;
  }

}

decorate(Store, {
  addDialogOpen: observable,
  updateDialogOpen: observable,
  columnFilterDialogOpen: observable,
  tableFields: observable,
  updateRecordOldInfo: observable,
  updateRecordInfo: observable,
});

var LocalStore = window.LocalStore = new Store;
export default LocalStore;
